import { View, ProgressView, PLATFORM_OVERLAY_SMALL } from "@gaming/srvg-classes-core";
import { LivetableWidget } from "../../../widgets/View/VfWidget/LivetableWidget";
import { GroupResultWidget } from "../../../widgets/View/VfWidget/GroupResultWidget";
import { TeamStatisticsGalleryView } from "../TeamStatisticsGalleryView";
import { LivetableLeagueWidget } from "../../../widgets/View/VfWidget/LivetableLeagueWidget";
import { COMPETITIONTYPE_CUP } from "../../Data/CompetitionStage";

export class PreMatchOverlay extends View {

    livetableWidget: LivetableWidget;
    livetableLeagueWidget: LivetableWidget;
    groupResultWidget: GroupResultWidget;
    teamStatisticsGalleryView: TeamStatisticsGalleryView;
    progressView: ProgressView;
    subViewRotationInterval: number;

    constructor( options ) {
        options = options || {};
        super( options );

        this.livetableWidget = null;
        this.livetableLeagueWidget = null;
        this.groupResultWidget = null;
        this.teamStatisticsGalleryView = this.addSubView( new TeamStatisticsGalleryView( { selector: '#teamStatisticsGalleryView' } ) )
        this.subViewRotationInterval = srvg.overlay_timings.pre_match.rotation_interval || 5;

        if( srvg.widgets.enabled ) {
            // Livetable widget, if it is enabled in configuration file while LivetableLeague widget is not
            // show in pre match overlay
            if(srvg.widgets.widgets['livetable'].enabled && !srvg.widgets.widgets['livetableLeague'].enabled){

                this.livetableWidget = this.addSubView(new LivetableWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: '#prematchLiveGroupTableWidgetOverlay',
                    // hide group name, because overlay at the top (group result) has still a headline
                    showGroupHeader: false,
                    // hide difference columns
                    diff: false,
                    played: srvg.widgets.overlaySettings.played,
                    // mark group if currently playing
                    showActiveGroupBorder: false,
                    // Subscribe to livescore public channel event and show the active group
                    // for the matches currently playing (group parameter should be omitted).
                    subscribeToLiveScoreMatch: true,
                    platform: PLATFORM_OVERLAY_SMALL
                }));
            }
            // LivetableLeague widget, if it is enabled in configuration file while Livetable widget is not
            // show in pre match overlay
            else if(! srvg.widgets.widgets['livetable'].enabled && srvg.widgets.widgets['livetableLeague'].enabled){

                // as we have no group result widget in league mode we hide the according div
                $('#prematchGroupResultWidgetOverlay').hide();

                // change classes as league livetable widget needs more space compared to 'standard' livetable widget
                $('#prematchLiveGroupTableWidgetOverlay').removeClass('LiveGroupTableWidget');
                $('#prematchLiveGroupTableWidgetOverlay').addClass('LiveGroupTableLeagueWidget');

                this.livetableLeagueWidget = this.addSubView(new LivetableLeagueWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: '#prematchLiveGroupTableWidgetOverlay',
                    // hide group name, because overlay at the top (group result) has still a headline
                    showHeader: false,
                    // hide columns
                    diff: false,
                    wins: false,
                    draws: false,
                    losses: false,
                    form: false,
                    games: true,
                    formlabel: false,
                    // Subscribe to livescore public channel event and show the active group
                    // for the matches currently playing (group parameter should be omitted).
                    subscribeToLiveScoreMatch: true,
                    platform: PLATFORM_OVERLAY_SMALL
                }));
            }

            // Groupresults widget, if it is enabled in configuration file
            // show in pre match overlay
            if (srvg.widgets.widgets['groupresult'].enabled) {
                this.groupResultWidget = this.addSubView(new GroupResultWidget({
                    // group of widgets able to communicate with each other
                    widgetGroup: srvg.widgets.widget_group,
                    // container in CupView.ctp
                    selector: '#prematchGroupResultWidgetOverlay',
                    // transparent background in several sizes
                    platform: PLATFORM_OVERLAY_SMALL,
                    // zoomed level
                    zoom: srvg.widgets.zoom,
                    zoomPosition: srvg.widgets.zoom_position,
                    // show group name
                    showGroupHeader: true,
                    // mark group if currently playing
                    showActiveGroupBorder: false,
                    // refreshes simultaneously with livescores, independently from widget group
                    subscribeToLiveScoreMatch: true,
                    showFlags: srvg.widgets.overlaySettings.showFlags
                }));

            }
        }
        this.progressView = this.addSubView( new ProgressView( { selector: this.selector + ' .progressView'} ) );
    }

    show( animate?:boolean ) {
        if( app.timeline.currentCompetitionStageModel.competitionStage.stageType == COMPETITIONTYPE_CUP ) {
            this.livetableWidget.hide();
            this.groupResultWidget.hide();
        }
        else {
            if(srvg.widgets.widgets['livetable'].enabled && !srvg.widgets.widgets['livetableLeague'].enabled) {
                this.livetableWidget.show();
            }
            else {
                this.livetableLeagueWidget.show();
            }
            if(this.groupResultWidget) {
                this.groupResultWidget.show();
            }
        }
        var that = this;
        this.teamStatisticsGalleryView.galleryPageContainerView.startSubViewRotation( this.subViewRotationInterval, function() {
            that.teamStatisticsGalleryView.pagerView.selectNextIndex();
        } );
        super.show( animate );
    }

    hide( animate?:boolean ) {
        this.teamStatisticsGalleryView.galleryPageContainerView.stopSubViewRotation();
        super.hide( animate );
    }
}